import React from 'react'
import { Divider, List, ListItem, ListItemText, makeStyles, Typography } from '@material-ui/core'

import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css'

import { Link, useLocation } from 'react-router-dom'
import { ROUTES } from '../shared/constants'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    background: 'rgba(221, 226, 239, 0.33)',
    border: '1px solid #E0E4F1',
    boxSizing: 'borderBox',
  },
  accounts: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#313131',
  },
  hover: {
    '&:hover': {
      backgroundColor: '#32499F !important',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '19px',
      display: 'flex',
      color: '#FFFFFF',
    },
  },
  filter1: {
    paddingLeft: theme.spacing(4),
  },
  filter2: {
    paddingLeft: theme.spacing(8),
  },
  footer: {
    width: '100%',
    display: 'flex',
  },
}))

export default function SideMenuList({ heading, selectedDate, setSelectedDate }) {
  const [openPosition, setOpenPosition] = React.useState(false)
  const [openNew, setOpenNew] = React.useState(false)
  const [openRegion, setOpenRegion] = React.useState(false)
  const [openZone, setOpenZone] = React.useState(false)
  const classes = useStyles()
  const handleOpenPosition = () => {
    setOpenPosition(!openPosition)
  }
  const handleOpenRegion = () => {
    setOpenRegion(!openRegion)
  }
  const handleOpenZone = () => {
    setOpenZone(!openZone)
  }

  const filter = [
    {
      heading: 'Position',
      filterOption: [
        { label: 'Sales Executive' },
        { label: 'Sales Associate' },
        { label: 'Developer' },
        { label: 'Designer' },
      ],
      handleChange: handleOpenPosition,
      openType: openPosition,
    },
    {
      heading: 'Region',
      filterOption: [{ label: 'India' }, { label: 'Australia' }],
      handleChange: handleOpenRegion,
      openType: openRegion,
    },
    {
      heading: 'Zone',
      filterOption: [{ label: 'South' }, { label: 'North' }],
      handleChange: handleOpenZone,
      openType: openZone,
    },
  ]

  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }
  const location = useLocation()

  return (
    <>
      {location.pathname === ROUTES.SETTING ||
      location.pathname === ROUTES.BUSINESS ||
      location.pathname === ROUTES.BUSINESS_ZONES ||
      location.pathname === ROUTES.BUSINESS_STORES ? (
        <List component="nav" className={classes.root} aria-label="mailbox folders">
          <ListItem button>
            <Typography className={classes.accounts}>Accounts</Typography>
          </ListItem>
          <Divider />
          <Link to="/business_configuration" style={{ textDecoration: 'none', color: 'black' }}>
            <ListItem button divider className={classes.hover}>
              <ListItemText
                primary="Business Configuration"
                style={{
                  marginLeft: 10,
                }}
              />
            </ListItem>
          </Link>
          <Link to="/business_zones" style={{ textDecoration: 'none', color: 'black' }}>
            <ListItem button className={classes.hover} divider>
              <ListItemText
                primary="Business Zones"
                style={{
                  marginLeft: 10,
                }}
              />
            </ListItem>
          </Link>
          <Link to="/business_stores" style={{ textDecoration: 'none', color: 'black' }}>
            <ListItem button className={classes.hover} divider>
              <ListItemText
                primary="Stores"
                style={{
                  marginLeft: 10,
                }}
              />
            </ListItem>
          </Link>
          <Link to="/business_configuration" style={{ textDecoration: 'none', color: 'black' }}>
            <ListItem button className={classes.hover} divider>
              <ListItemText
                primary="Hierarchy"
                style={{
                  marginLeft: 10,
                }}
              />
            </ListItem>
          </Link>
          <Link to="/business_configuration" style={{ textDecoration: 'none', color: 'black' }}>
            <ListItem button className={classes.hover}>
              <ListItemText
                primary="Holiday setup"
                style={{
                  marginLeft: 10,
                }}
              />
            </ListItem>
          </Link>
        </List>
      ) : null}
      {/* <div className={classes.footer}>
        <PoweredByNural />
      </div> */}
    </>
  )
}

{
  /* <div>
  {heading === 'Attendance' || heading === 'Leave Requests' ? (
    <div style={{ width: '100%', height: 'auto', margin: '0px auto', display: 'flex' }}>
    <Calendar ranges={[selectionRange]} onChange={() => {}} />
    </div>
    ) : null} */
}

{
  /* <PieChart /> */
}

{
  /* <List component="nav">
  <ListItem button onClick={() => setOpenNew(!openNew)}>
    <ListItemText primary="Filter" />
    {openNew ? <ExpandLess /> : <ExpandMore />}
  </ListItem>
</List>
<CustomList filter={filter} openMain={openNew} />
</div> */
}

{
  /* <div className={classes.footer}>
<PoweredByNural />
</div> */
}
